import * as moment from 'moment';
import { interval, Subscription } from 'rxjs';

export function formatTime(totalSeconds: number): string {
  const hours = Math.floor(totalSeconds / 3600).toString().padStart(2, '0');
  const minutes = Math.floor((totalSeconds % 3600) / 60).toString().padStart(2, '0');
  const seconds = (totalSeconds % 60).toString().padStart(2, '0');
  return `${hours}:${minutes}:${seconds}`;
}

export function startTimer(startFrom: number, callback: (seconds: number) => void): Subscription {
  const startTime = Date.now() - startFrom * 1000;
  return interval(1000).subscribe(() => {
    const now = Date.now();
    const elapsed = Math.floor((now - startTime) / 1000);
    callback(elapsed);
  });
}

export function pauseTimer(subscription: Subscription | null): void {
  if (subscription) {
    subscription.unsubscribe();
  }
}

export function getCurrentTimeFormatted(marks:any, active:boolean=false): string {
  let hours = null
  let minutes = null
  const intervals = marks?.data?.aIntervals ?? [];
  if (intervals.length === 0 || active === true) {
    const now = new Date();
    hours = now.getHours().toString().padStart(2, '0');
    minutes = now.getMinutes().toString().padStart(2, '0');
  }else{
    marks.data.aIntervals.sort((a: any, b: any) => {
      if (a.nInterval !== b.nInterval) {
        return a.nInterval - b.nInterval;
      }
      return a.nType_Mark - b.nType_Mark;
    });
    const lastInterval = intervals[intervals.length - 1];
    const lastDate = new Date(lastInterval.dDate);
    hours = lastDate.getHours().toString().padStart(2, '0');
    minutes = lastDate.getMinutes().toString().padStart(2, '0');
  }
  return `${hours}:${minutes}`;
}


export function calculateTotalWorkedSeconds(intervals: any[]): number {
  let total = 0;
  const now = new Date();

  for (let i = 0; i < intervals.length; i += 2) {
    const start = new Date(intervals[i].dDate);
    if (i + 1 < intervals.length && intervals[i + 1].nType_Mark === 2) {
      const end = new Date(intervals[i + 1].dDate);
      total += Math.floor((end.getTime() - start.getTime()) / 1000);
    } 
    else if (intervals[i].nType_Mark === 1 && i === intervals.length - 1) {
      total += Math.floor((now.getTime() - start.getTime()) / 1000);
    }
  }
  return total;
}
